// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2J353","field":"styles_field__3gF7-","errorMessage":"styles_errorMessage__2KLV4","checkbox":"styles_checkbox__3tGEv","submit":"styles_submit__3j8CV"};